export default __webpack_public_path__ + "static/media/montserrat-medium.b8c6753b.ttf";